import { noop } from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import {
  withSiteMap,
  processorSet
} from '@bingads-webui-react/with-site-map';
import { StyledGlobalMenu } from './global-menu';

export class GlobalMenuWithAccount extends React.PureComponent {
  render() {
    const WrappedGlobalMenu =
      withSiteMap(StyledGlobalMenu, processorSet.basic);
    // TODO: Currently switch the account will perform full refresh for the page.
    // So we won't need this call now.
    // Once CCUI team support the permission update and account call support the warm data
    // Will switch back to use the Account call which won't have the performance issue.
    const { CurrentAccount, Urls } = this.props.serverContext;
    const {
      Id, Name, AccountNumber, AdvertiserCustomerID,
    } = CurrentAccount;
    const account = {
      Id,
      Name,
      AccountNumber,
      ParentCustomerId: AdvertiserCustomerID,
    };

    const supportUrl = Urls.RootUIUrl.replace(/^https:\/\//, 'https://internal.');
    return (
      <WrappedGlobalMenu
        account={account}
        serverContext={this.props.serverContext}
        settingsContext={this.props.settingsContext}
        supportUrl={supportUrl}
        NotificationsBar={this.props.NotificationsBar}
        CustomizedToolsBar={this.props.CustomizedToolsBar}
        hide={this.props.hide}
        onLogoClick={this.props.onLogoClick}
      />
    );
  }
}

GlobalMenuWithAccount.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({}),
    Urls: PropTypes.shape({}),
  }).isRequired,
  settingsContext: PropTypes.shape({}).isRequired,
  NotificationsBar: PropTypes.elementType.isRequired,
  CustomizedToolsBar: PropTypes.elementType,
  hide: PropTypes.shape({}),
  onLogoClick: PropTypes.func,
};

GlobalMenuWithAccount.defaultProps = {
  hide: {},
  CustomizedToolsBar: null,
  onLogoClick: noop,
};
